import { useDispatch } from "react-redux";

import { openHostModal, setModalOpener } from "../../actions";
import {
  closeAgentContactDrawer,
  openAgentContactDrawer,
  setModalViewType
} from "../../slices/uiSlice";

export const useUIBehavior = () => {
  const dispatch = useDispatch();

  return {
    closeAgentContactDrawer: () => dispatch(closeAgentContactDrawer()),
    openAgentContactDrawer: () => dispatch(openAgentContactDrawer()),
    openHostModal: () => dispatch(openHostModal()),
    setModalOpener: value => dispatch(setModalOpener(value)),
    setModalViewType: value => dispatch(setModalViewType(value))
  };
};
